import styled from '@emotion/styled';
import type { CheckboxSize, CheckboxVariant } from './types';

type ControlProps = {
  $size: CheckboxSize;
  $checked?: boolean;
  $disabled?: boolean;
};

type RootProps = {
  $variant: CheckboxVariant;
  $checked?: boolean;
  $disabled?: boolean;
};

export const Root = styled.label<RootProps>`
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme?.space?.sm ?? '0.5rem'};
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ $disabled, theme }) =>
    $disabled ? theme?.component?.checkbox?.disabledOpacity ?? 0.5 : 1};
  box-sizing: border-box;
  user-select: none;

  ${({ theme, $variant, $checked }) =>
    $variant === 'card'
      ? `
    width: 100%;
    padding: ${theme?.component?.checkbox?.card?.padding ?? '1rem'};
    background: ${
      $checked
        ? theme?.component?.checkbox?.card?.selectedBackground ??
          'rgba(47, 128, 106, 0.08)'
        : theme?.component?.checkbox?.card?.backgroundColor ?? '#ffffff'
    };
    border: 1px solid ${
      $checked
        ? theme?.component?.checkbox?.card?.selectedBorderColor ?? '#292929'
        : theme?.component?.checkbox?.card?.borderColor ?? '#e5e5e5'
    };
    border-radius: ${theme?.component?.checkbox?.card?.borderRadius ?? '8px'};
    transition: border-color 0.15s ease, background 0.15s ease;

    @media (hover: hover) and (pointer: fine) {
      &:hover {
        border-color: ${
          theme?.component?.checkbox?.card?.hoverBorderColor ?? '#292929'
        };
      }
    }
  `
      : ''}
`;

export const HiddenInput = styled.input`
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
  pointer-events: none;
`;

export const Box = styled.span<ControlProps>`
  position: relative;
  flex-shrink: 0;
  box-sizing: border-box;
  width: ${({ theme, $size }) =>
    theme?.component?.checkbox?.size?.[$size]?.width ?? '18px'};
  height: ${({ theme, $size }) =>
    theme?.component?.checkbox?.size?.[$size]?.height ?? '18px'};
  border: 2px solid
    ${({ theme, $checked }) =>
      $checked
        ? theme?.component?.checkbox?.checkedBackground ?? '#292929'
        : theme?.component?.checkbox?.borderColor ?? '#e5e5e5'};
  border-radius: 3px;
  background: ${({ theme, $checked }) =>
    $checked
      ? theme?.component?.checkbox?.checkedBackground ?? '#292929'
      : 'transparent'};
  transition: all 0.15s ease;

  &::after {
    content: '';
    position: absolute;
    display: ${({ $checked }) => ($checked ? 'block' : 'none')};
    left: 50%;
    top: 45%;
    width: 35%;
    height: 60%;
    border: solid
      ${({ theme }) => theme?.component?.checkbox?.checkedColor ?? '#ffffff'};
    border-width: 0 2px 2px 0;
    transform: translate(-50%, -55%) rotate(45deg);
  }
`;

export const LabelText = styled.span`
  font-size: ${({ theme }) => theme?.fontSizes?.[2] ?? 14}px;
  color: ${({ theme }) => theme?.colors?.text?.primary ?? '#292929'};
  line-height: 1.4;
`;
